"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMethodsInTarget = void 0;
const getMethodsInTarget = (target) => {
    const methods = {};
    if (typeof target != 'object')
        return methods;
    const targetObj = Object(target);
    for (let classMethod in targetObj) {
        if (typeof targetObj[classMethod] === "function") {
            methods[classMethod] = targetObj[classMethod];
        }
    }
    return methods;
};
exports.getMethodsInTarget = getMethodsInTarget;
